import React from 'react';
import PropTypes from 'prop-types';
import workspaceService from 'services/WorkspaceService';
import useLearnerGrades from './useLearnerGrades';
import useChildLearnerGrades from './useChildLearnerGrades';
import GradesGrid from '../GradesGrid';

function GradesGridContainer({ cohortId, deployment, selectedActivityId, ...props }) {
  const { deploymentId, activityId: rootActivityId } = deployment;
  const activityId = selectedActivityId || rootActivityId;
  const workspaceId = workspaceService.getSelectedWorkspaceId();

  const {
    error,
    loading: gradeReportLoading,
    data: {
      activity,
      childWalkables,
      enrollments,
    },
  } = useLearnerGrades(cohortId, deploymentId, activityId, workspaceId);

  const {
    errors,
    data: scoresByChildWalkable,
  } = useChildLearnerGrades(cohortId, deploymentId, activityId, childWalkables);

  if (error || errors) {
    // eslint-disable-next-line no-console
    console.error(error || errors);
    return null;
  }

  return (
    <GradesGrid
      isLoading={gradeReportLoading}
      activity={activity}
      childWalkables={childWalkables}
      enrollments={enrollments}
      cohortId={cohortId}
      deploymentId={deploymentId}
      scoresByChildWalkable={scoresByChildWalkable}
      workspaceId={workspaceId}
      {...props}
    />
  );
}

GradesGridContainer.propTypes = {
  cohortId: PropTypes.string.isRequired,
  deployment: PropTypes.object,
  selectedActivityId: PropTypes.string,
};

export default GradesGridContainer;
